import { 
    useState, 
    useMemo,
} from "react";
import { 
    Box,
    CircularProgress, 
} from "@mui/material";

const WebsiteFavicon = ({ url }) => {

    // Extract domain from full URL or use as is if it's already a domain
    const domain = useMemo(() => {
        try {
            return new URL(url).hostname; // Extract domain from full URL
        } catch {
            return url; // If input is already a domain, use it directly
        }
    }, [url]);

    const [faviconSrc, setFaviconSrc] = useState(`https://www.google.com/s2/favicons?sz=64&domain=${domain}`);
    const [hasFavicon, setHasFavicon] = useState(true);
    const [loading, setLoading] = useState(true);

    if (!hasFavicon) return null;

    return (
        <Box sx={{ width: 20, height: 20, position: "relative", display: "inline-block" }}>
            {loading && (
                <CircularProgress size={18} sx={{position: "absolute"}} />
            )}
            <Image 
                domain={domain}
                faviconSrc={faviconSrc}
                setLoading={setLoading} 
                setFaviconSrc={setFaviconSrc} 
                setHasFavicon={setHasFavicon}
            />
        </Box>
    );
};

const Image = ({ domain, faviconSrc, setLoading, setFaviconSrc, setHasFavicon }) => {
    return (
        <img 
            src={faviconSrc} 
            alt="favicon" 
            style={{ 
                width: 20, 
                height: 20,
                borderRadius: '50%', 
                display: "block",
            }}
            onLoad={() => setLoading(false)}
            onError={() => {
                if (faviconSrc.includes("https://www.google.com/s2/favicons")) {
                    setFaviconSrc(`https://icons.duckduckgo.com/ip3/${domain}.ico`);  // Switch to DuckDuckGo if Google fails
                } else {
                    setHasFavicon(false);
                }
            }}
        />
    )
}

export default WebsiteFavicon;